const apiPath = "/customs/customs-transactions";
const path = "CustomsTransactionsModule";

const CustomsTransactionsAPIsConstants = {
  API_PATH: `${apiPath}`,
};

const CustomsTransactionsActions = {
  ADD_ITEM: `${path}/addItem`,
  UPDATE_ITEM: `${path}/updateItem`,
  EDIT_ITEM: `${path}/editItem`,
  FIND_ITEM_BY_ID: `${path}/findItemById`,
  GET_INIT_DATA : `${path}/getInitData`,
};

export { CustomsTransactionsAPIsConstants, CustomsTransactionsActions };
